import * as datadog from "@/libs/datadog";

export default function identifyUser(user) {
  datadog.init(user)
}
